/**
 * Basic TomSelect for a one selection dropdown with visible placeholder
 *
 */
import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  static values = {
    closeAfterSelect: { type: Boolean, default: false },
  };

  connect() {
    // Check if TomSelect is already initialized
    if (this.element.tomselect) {
      return;
    }

    const plugins = this.element.attributes["multiple"]
      ? ["input_autogrow", "remove_button"]
      : ["input_autogrow"];
    var config = {
      plugins: plugins,
      hidePlaceholder: true,
      closeAfterSelect: this.closeAfterSelectValue,
    };

    this.tomselect = new TomSelect(this.element, config);

    // Support for content editor's section ordering drag-and-drop functionality.
    if ("_basicSelectPreservedValue" in this.element) {
      this.tomselect.setValue(
        this.element._basicSelectPreservedValue,
        true, // silent: TomSelect-internal change suppressed; we re-emit below
      );
      delete this.element._basicSelectPreservedValue;

      this.element.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  disconnect() {
    // Clean up TomSelect instance when controller disconnects
    if (this.tomselect) {
      // Stash the current selection so a reconnect (e.g. after a DOM move)
      // can restore it. Captured before destroy(), while it's still accurate.
      this.element._basicSelectPreservedValue = this.tomselect.getValue();
      try {
        this.tomselect.destroy();
      } catch (e) {
        // Ignore errors during cleanup - element may already be removed from DOM
      }
      this.tomselect = null;
    }
  }
}
